import React from 'react';

interface SliderArrowProps {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type: 'prev' | 'next';
}

const SliderArrow: React.FC<SliderArrowProps> = ({
  className,
  onClick,
  type
}) => {
  const rightPosition = type === 'prev' ? 'right-[62px]' : 'right-2.5';

  return (
    <button
      onClick={onClick}
      className={`absolute top-0 ${rightPosition} z-10 w-10 h-10 rounded-full border border-[#DFD8CD] flex items-center justify-center outline-none bg-brand-white transition-colors ${className?.includes('slick-disabled') ? 'opacity-50 cursor-not-allowed hover:border-[#DFD8CD]' : 'hover:border-brand-green'}`}
    >
      {type === 'prev' ? (
        <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4.99219H2.8237"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round" />
          <path d="M6.62305 1L2 4.9929L6.62305 9"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round" />
        </svg>
      ) : (
        <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 4.99219H10.1763"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round" />
          <path d="M6.37695 1L11 4.9929L6.37695 9"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeMiterlimit="10"
                strokeLinecap="round" />
        </svg>
      )}
    </button>
  );
};

export const PrevArrow = (props: any) => <SliderArrow {...props} type="prev" />;
export const NextArrow = (props: any) => <SliderArrow {...props} type="next" />;
